<i18n>
{
    "no": {
      "header": "Identifisering",
      "expired": "Økten har utløpt. Lukk nettleser og forsøk igjen."
    },
    "en": {
      "header": "Identification",
      "expired": "This session has expired. Please close this browser window and try again."
    }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div>
        <TnHeading type="h1" size="m" align="center" class="margin-vertical-l">
          {{ t('header') }}
        </TnHeading>
        <TnNotificationInline horizontal status="critical" full-width>
          {{ t('expired') }}
        </TnNotificationInline>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { TnHeading, TnNotificationInline } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  const signUpRequestId = route.query.request as string | undefined;
  const errorCode = route.query.error as string | undefined;
  const signUpResponse = route.query.response as string | undefined;

  if (signUpResponse) {
    window.location.href = '/external/callback';
    return;
  }

  if (signUpRequestId && errorCode) {
    await router.push({
      name: 'ibis-sign-up-phone',
      query: { request: signUpRequestId, error: errorCode },
    });
  }
});
</script>
